export default __webpack_public_path__ + "static/media/petgramImg_1.995f211f.png";